import { Component, OnInit, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef, ViewChildren } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';
import { MessageService } from '../../../@pages/components/message/message.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ErrorHandlingService } from '../../../shared/services/error-handling.service';
import * as $ from 'jquery';
import { Utils } from '../../../shared/services/utils.service';
import { pgDatePickerComponent } from '../../../@pages/components/datepicker/datepicker.component';
import * as moment from 'moment';
import { PermissionService } from '../../../shared/services/permission.service';
import { PermissionGroupService } from '../../../shared/services/permission-group.service';
import { PaginatedSelectComponent } from '../../components/paginated-select/paginated-select.component';
import { SettingsModel } from '../../../shared/models/settings.model';
import { SettingsBuildData } from '../settings.build-data';
import { SettingsService } from '../../../shared/services/settings.service';
import { PartService } from '../../../shared/services/part.service';

@Component({
  selector: 'app-settings-detail',
  templateUrl: './settings-detail.component.html',
  styleUrls: ['./settings-detail.component.scss']
})
export class SettingsDetailComponent implements OnInit {

  @Input() external: boolean = false;
  @Output() saveEvent: EventEmitter<any> = new EventEmitter<any>();
  object: SettingsModel;
  roles: any[];
  @ViewChild('deleteModal', { static: true }) modalDelete: ModalDirective;
  errors: String[] = [];
  data = new SettingsBuildData();
  module = this.data.module;
  form: FormGroup;
  _set : SettingsModel[] = [];

  constructor(
    private service: SettingsService,
	private partService: PartService,
    private router: Router,
	private settingsService: SettingsService,
    private snapshot: ActivatedRoute,
    private authService: AuthService,
    private messageService: MessageService,
    private errorHandler: ErrorHandlingService,
    private utils: Utils,
    private cdr : ChangeDetectorRef,
    public permissionService : PermissionService
  ) { }

  ngOnInit() {
    let _this = this;
	this.loadSet();
    this.createForm({});
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.messageService.remove();
      }
    });
    this.snapshot.paramMap.subscribe(res => {
      if (res['params']['id'] && !_this.external) {
        this.loadData(res['params']['id']);
      }
    })
  }

  menuItems: any[] = [
    { action: 'delete', message: 'Delete ' + this.module.name, class: '', icon: 'fal fa-trash', permissions: ['delete_' + this.module.permission] }
  ];

  handleButtonPress = (event) => {
    switch (event) {
      case "delete":
        this.modalDelete.show();
        break;
      default:
        console.log(event);
        break;
    }
  }

  loadSet(){
	var _this = this;
	this.settingsService.getAll({}).subscribe(res => {
		for(var uObject of res['data'])
		{
			_this._set.push(new SettingsModel(uObject));
		}
	});
}

  incomingEvent:EventEmitter<any> = new EventEmitter<any>();
  incomingPaginatedSelectValue(fieldName, value) {
    let _this = this;
    _this.form.get(fieldName).setValue(value);
  }

  markTouched() {
    this.form.markAsTouched();
  }

  imageError: string;
  isImageSaved: boolean;
  cardImageBase64: string;

  fileChangeEvent(fileInput: any) {
    let _this = this;
    Utils.handleFileChange(fileInput).subscribe(res => {
      let success = res.success;
      if (success) {
        _this.cardImageBase64 = res.cardImageBase64;
        _this.isImageSaved = res.isImageSaved;
      }
      else {
        console.log("Failed to load file.");
      }
    });
  }

  @ViewChild('fromPicker', { static: true }) fromPicker: pgDatePickerComponent;
  @ViewChild('toPicker', { static: true }) toPicker: pgDatePickerComponent;
  fromDate: Date = new Date();
  toDate: Date = moment(new Date()).add(1, 'hour').toDate();
  forceRefresh(dateEvent) {
    let _this = this;
    Utils.forceRefresh(dateEvent,this.fromDate,this.toDate,this.fromPicker,this.toPicker).subscribe(res => {
      _this.cdr.detectChanges();
    })
  }

  _disabledStartDate = (startValue) => {
    return Utils._disabledStartDate(startValue,this.fromDate,this.toDate);
  };

  _disabledEndDate = (endValue) => {
    return Utils._disabledEndDate(endValue,this.fromDate,this.toDate);
  };

  removeImage() {
    this.cardImageBase64 = null;
    this.isImageSaved = false;
  }

  createForm(input, form?) {
    input = input || {};
    form ? form : this.form = SettingsModel.getFormGroup(input);
  }

  openFileUpload(ele) {
    $(ele).click();
  }

  hasPermission(permission) {
    return this.authService.hasPermission(permission);
  }

  isTouched(controlName) {
    return Utils.isFormTouched(this.form, controlName);
  }

  loading = {
    isFirstLoad: false,
    isLoading: false
  };

  loadData(id) {
    let _this = this;
    let checkLoadingSpinner = () => {
      if (!_this.loading.isFirstLoad) {
        _this.loading.isFirstLoad = true;
        _this.loading.isLoading = true;
      }
    }

    checkLoadingSpinner();

    this.service.get(id).subscribe(res => {
      _this.object = res['data'];
      _this.createForm(_this.object);
      _this.triggerFetch.emit(_this.form);
      _this.loading.isLoading = false;
    },
      err => {
        _this.loading.isLoading = false;
        console.log(err);
      });
  }

  //Variable & Function for <phone-input>
  triggerFetch: EventEmitter<FormGroup> = new EventEmitter<FormGroup>();
  updateForm(event) {
    this.form = event;
  }

  delete() {
    let _this = this;
    _this.isLoading = true;
    this.utils.delete(this.service, this.object.id, this.module.name, "/"+this.module.new_name).subscribe(res => {
      _this.isLoading = false;
    });
  }

  isFormValueChecked(controlName) {
    return this.form.get(controlName).value;
  }


  isSyncing = false;
  syncProcessCount = 0;
  syncProcessComplete = 0;

  resyncAll(){

	var _this = this;
	this.isSyncing = true;
	this.syncProcessComplete = 0;
	this.syncProcessCount = 1;

	this.utils.furnitureResyncAll().subscribe(res => {
		_this.syncProcessComplete += 1;
		
		this.partService.getAll('').subscribe(resPart => {
			
			let totalParts = resPart['meta']['total'];

			let offset = 0;
			let totalPerRequest = 50;

			
			_this.syncProcessCount += Math.ceil(totalParts/totalPerRequest);
			
			this.syncParts(totalPerRequest, offset);
			// while(totalParts > 0)
			// {	
			// 	// _this.syncProcessCount += 1;
				
			// }

		});
		
		
	});
  }

  syncParts(totalPerRequest, offset)
  {
	let _this = this; 
	this.utils.partResyncAll(totalPerRequest, offset).subscribe(resPart => {
		_this.syncProcessComplete += 1;

		offset += totalPerRequest;
		this.syncParts(totalPerRequest, offset);
		// console.log(offset + ' of ' + totalParts);

		if(_this.syncProcessComplete == _this.syncProcessCount)
		{
			setTimeout(() => {
				_this.isSyncing = false;
			}, 5000);
		}

	});		
	
		// totalParts -= totalPerRequest;		
  }

  photoChangeEvent(fileInput: any) {
    let _this = this;
    Utils.handleFileChange(fileInput).subscribe(res => {
      let success = res.success;
      if (success) {
        _this.cardImageBase64 = res.cardImageBase64;
        _this.isImageSaved = res.isImageSaved;
        _this.form.get('image').setValue(res.cardImageBase64);
      }
      else {
        console.log("Failed to load file.");
      }
    });
  }

  @Input() isLoading: boolean = false;


  @ViewChildren(PaginatedSelectComponent) paginatedSelects: PaginatedSelectComponent[];
  save() {
    let _this = this;
    _this.isLoading = true;

    // if(this.fromDate){
    //   _this.form.get("valid_from").setValue(moment(this.fromDate).format());
    // }

    // if(this.toDate){
    //   _this.form.get("valid_to").setValue(moment(this.fromDate).format());
    // }

    Utils.forceTouchPaginatedSelects(_this.paginatedSelects);
    Utils.handleFormSave(this.form, this.service, this.object, this.module.name, this.createForm, null).subscribe(res => {
      _this.isLoading = false;
      if (res['data']) {
        if (_this.external == true) {
          _this.saveEvent.emit(res['data']);
        }
        else {
          this.router.navigate(['/'+this.module.new_name+'/' + res['data']['id']]);
        }
        _this.utils.successMessage(_this.module.name+' saved.');
      }
      else{
        Utils.sendFormSaveError(res,this.module,this.utils);
      }
    })
  }


}
